import PreOrderItem from "./PreOrderItem";
import env from "../../env";
import { useEffect, useState } from "react";
import Paging from "../../modules/Components/Paging";
import { updateUrlWithFilters } from "../../utils/filterUtils";
import { getFiltersFromUrl } from "../../utils/filterUtils";
function PreOrderHolder(props) {
  const cart = props.cart;
  const total = props.cart && props.cart.cartDetail;
  function handleFilterChange(newFilters) {
    props.setPages(newFilters);
  }
  if (!cart) return <></>;
  else
    return (
      <section className="orders-sec">
        <div className="title">
          <p>سفارشات اخیر</p>
          <div className="orders-total">
            <p>تعداد سفارشات : {cart.faktorSize}</p>
          </div>
        </div>
        {cart.faktorData &&
          cart.faktorData.map((cart, i) => (
            <PreOrderItem
              key={i}
              data={cart}
              total={total}
              index={i}
              setCart={props.setCart}
              user={props.user}
            />
          ))}
        <Paging
          content={cart.faktorData}
          size={cart.faktorSize}
          setFilters={handleFilterChange}
          filters={props.Pages}
          lang={props.lang}
          updateUrlWithFilters={updateUrlWithFilters} // Pass the function as a prop
        />
      </section>
    );
}
export default PreOrderHolder;
